import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';
import { AuthCodeGrantService } from './auth-code-grant.service';
import { CredentialTokenOauth } from './core/CredentialTokenOauth';

@Component({
  selector: 'biz-auth-code-grant',
  template: ''
})
export class AuthCodeGrantComponent implements OnInit {
  url: string;
  myWindow;
  loop;
  code: string;
  properties: any[];
  credentialTokenOauth: ICredentialTokenOauth;

  @Output() onOauthData = new EventEmitter<any>();

  constructor(private authCodeGrantService: AuthCodeGrantService, private _toastService: BzgToastService,
    private _translateService: TranslateService) { }

  ngOnInit() { }

  public openWindow(url: string, properties: any[]) {
    this.url = url;
    this.properties = properties;
    if (!this.myWindow) {
      this.myWindow = window.open(this.url, '', 'width=730,height=700,left=500,top=350');
      this.myWindow.focus();

      this.loop = setInterval(() => {
        if (this.myWindow && this.myWindow.closed) {
          clearInterval(this.loop);
          try {
            if (this.myWindow.document) {
              let url = this.myWindow.document.URL;
              const myArr = url.split("code=");
              let code = myArr[1].split("&")[0];
              this.getToken(code);
            }else{
              this._translateService.get('GLOBAL.GRANT_TOKEN_CODE_CANNOT_BE_OBTAINED').subscribe((message: string) => {
                this.showMessage(message, 'error', 0);
              });
            }
          } catch (e) {            
          } finally {
            this.myWindow = null;
          }
        }
      }, 1000);
    } else {
      this.myWindow.focus();
    }
  }

  async getToken(code: string) {
    this.credentialTokenOauth = await this.authCodeGrantService.getTokenOauthCodeGrant(code, this.properties);    
    if (this.credentialTokenOauth) {
      this.onOauthData.emit(new CredentialTokenOauth(this.credentialTokenOauth));
      this._translateService.get('GLOBAL.TOKEN_CODE_GRANT_WAS_SUCCESSFULLY').subscribe((message: string) => {
        this.showMessage(message, 'success', 5000);
      });
    }
  }

  showMessage(message:string, type: BzgToastType, duration: number){   
    this._toastService.open(
      message,
      {
        type: type,
        duration: duration,
        verticalPosition: 'top',
        horizontalPosition: 'right'
      });
  }
}

